import React, { useState, useEffect, useRef, useMemo } from 'react'
import { Helmet } from 'react-helmet-async'
import './styles.scss'
import UploadExcel from './UploadExcel'

const Import: React.FC = () => {
    return (
        <>
            <Helmet>
                <title>Đặt hàng số lượng lớn - Dược Tâm Hạnh</title>
                <meta name="description" content="Đặt hàng số lượng lớn bằng file Excel tại Dược Tâm Hạnh." />
            </Helmet>
            <div className='style_container__3o3Ct !mt-[10px] !mb-[32px]'>
                <div className="styles_wrapDirect__RrlO8 MuiBox-root css-0">
                    <nav className="MuiTypography-root MuiBreadcrumbs-root MuiTypography-body1 MuiTypography-colorTextSecondary" aria-label="breadcrumb">
                        <ol className="MuiBreadcrumbs-ol">
                            <li className="MuiBreadcrumbs-li">
                                <a className="styles_item_breadcrumb__eYGFd" href="/">Trang chủ</a>
                            </li>
                            <li aria-hidden="true" className="MuiBreadcrumbs-separator" ins-init-condition="#Lk11aUJyZWFkY3J1bWJzLW9sIGxpOm5vdCg6Zmlyc3Qp">
                                <svg className="MuiSvgIcon-root MuiSvgIcon-fontSizeSmall" focusable="false" viewBox="0 0 24 24" aria-hidden="true">
                                    <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"></path>
                                </svg>
                            </li>
                            <li className="MuiBreadcrumbs-li" ins-init-condition="#Lk11aUJyZWFkY3J1bWJzLW9sIGxpOm5vdCg6Zmlyc3Qp">
                                <span className="styles_item_breadcrumb__eYGFd styles_last_breadcrumb__c7IQm">Đặt Hàng Số Lượng Lớn</span>
                            </li>
                        </ol>
                    </nav>
                </div>
                <UploadExcel />
            </div>
        </>
    )
}

export default Import
